import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

// Guards
import { AuthenticationGuard } from './core/guards/authentication/authentication.guard';
import { CheckActivationCodeGuard } from './core/guards/check-activation-code/check-activation-code.guard';
import { ConfigFileGuard } from './core/guards/config-file/config-file.guard';
import { ConnectionGuard } from './core/guards/connection/connection.guard';
import { PwaGuard } from './core/guards/pwa/pwa.guard';
import { RouteGuard } from './core/guards/route/route.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'information',
    loadChildren: () => import('./modules/information/information.module').then((m) => m.InformationPageModule),
    canActivate: [RouteGuard],
  },
  {
    path: 'menu',
    loadChildren: () => import('./modules/menu/menu.module').then((m) => m.MenuPageModule),
    canActivate: [],
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsPageModule),
    canActivate: [RouteGuard],
  },
  {
    path: 'play/:ID',
    loadChildren: () => import('./modules/play/play.module').then((m) => m.PlayPageModule),
    canActivate: [],
  },
  {
    path: 'wines-and-spirits',
    loadChildren: () =>
      import('./modules/wines-and-spirits/wines-and-spirits.module').then((m) => m.WinesAndSpiritsPageModule),
    canActivate: [],
  },
  {
    path: 'by-producers',
    loadChildren: () => import('./modules/by-producers/by-producers.module').then((m) => m.ByProducersPageModule),
    canActivate: [],
  },
  {
    path: 'choose-byproducer/:ID',
    loadChildren: () =>
      import('./modules/choose-byproducer/choose-byproducer-producers.module').then(
        (m) => m.ChooseByProducersPageModule,
      ),
    canActivate: [],
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
    canActivate: [ConnectionGuard, RouteGuard, CheckActivationCodeGuard, ConfigFileGuard, AuthenticationGuard],
  },
  {
    path: 'splash',
    loadChildren: () => import('./modules/splash/splash.module').then((m) => m.SplashModule),
    canActivate: [RouteGuard],
  },
];

if (environment.production) {
  routes.forEach((route) => {
    if (route.path !== '') {
      route.canActivate.push(PwaGuard);
    }
  });
}

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
